import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=e97f1364"
import script from "./WizardView.vue?vue&type=script&lang=js"
export * from "./WizardView.vue?vue&type=script&lang=js"
import style0 from "./WizardView.vue?vue&type=style&index=0&id=e97f1364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports